import React from "react";
import { motion } from "framer-motion";
import { Icon } from "@iconify/react";
import { useScrollAnimation } from "../../hooks/useScrollAnimation";
import "./HowItWorks.css";

const steps = [
  { id: 1, title: "Choose Location", desc: "Enter your address to see restaurants near you.", icon: "mdi:map-marker" },
  { id: 2, title: "Select Your Food", desc: "Browse menus and add your favorite dishes to the cart.", icon: "mdi:food" },
  { id: 3, title: "Fast Delivery", desc: "Get your food delivered hot and fresh in 30 minutes.", icon: "mdi:moped" },
];

const HowItWorks = () => {
  const { ref, inView } = useScrollAnimation();

  return (
    <section className="hiw-section" ref={ref}>
      <div className="hiw-container">
        <motion.h2 
          className="hiw-title"
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.5 }}
        >
          How It Works
        </motion.h2>

        <div className="hiw-grid">
          {/* Connector Line */}
          <svg className="hiw-connector" preserveAspectRatio="none" viewBox="0 0 100 2">
            <motion.line 
              x1="0" y1="1" x2="100" y2="1" 
              stroke="var(--primary)" 
              strokeWidth="2" 
              strokeDasharray="4 4"
              initial={{ pathLength: 0 }}
              animate={inView ? { pathLength: 1 } : {}}
              transition={{ duration: 1.5, delay: 0.5, ease: "easeInOut" }}
            />
          </svg>

          {steps.map((step, index) => (
            <motion.div 
              key={step.id} 
              className="hiw-step"
              initial={{ opacity: 0, y: 30 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.5, delay: index * 0.3 }}
            >
              <div className="hiw-icon-container">
                <Icon icon={step.icon} />
                <span className="hiw-step-number">{step.id}</span>
              </div>
              <h3>{step.title}</h3>
              <p>{step.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
